import ReactGA from "react-ga4";

const setupGoogleAnalytics = () => {
  ReactGA.initialize("G-2SZQ8WZBXW");
};

export default setupGoogleAnalytics;
